import React from "react";
import { motion } from "framer-motion";


const services = [
  {
    title: "Technical Services",
    image: "Images/Engine.jpg",
    content: (
      <>
        <p>
          Our team of experienced Chief Engineers with a rich and varied
          background in different aspects of shipping from Tankers to Containers
          to Offshore vessels, from Technical Managers to Class Surveyors are
          well equipped to provide structured solutions tailor made to the
          various requirements of ship owners and managers.
        </p>
        <ol className="list-disc list-inside space-y-1 mt-2">
          <li>Full Technical Management of Vessels.</li>
          <li>Dry-docking planning and execution support.</li>
          <li>Pre-Purchase Vessel Inspections.</li>
          <li>
            Technical audits and Inspections in line with RightShip and
            TMSA/SIRE requirements e.g. Engineering and Bunker Audits.
          </li>
          <li>New Vessel Building Support</li>
        </ol>
      </>
    ),
  },
  {
    title: "Marine Services",
    image: "Images/Marine.jpg",
    content: (
      <>
        <p>
          We offer various services to assist our clients in optimising their
          vessel operations in order to obtain the best results with respect to
          regulatory compliance, commercial performance, inspections and safety.
        </p>
        <ul className="list-disc list-inside space-y-1 mt-2">
          <li>Marine audits such as Navigation, Cargo, Mooring audits.</li>
          <li>VDR analysis services.</li>
          <li>
            Cargo and Safety Supervision/Surveys (Tankers, Bulk and Containers).
          </li>
          <li>Accident and Incident Investigations.</li>
        </ul>
      </>
    ),
  },
  {
    title: "Crewing Services",
    image: "Images/sea_farer1.png",
    content: (
      <p>
        As a holder of an Indian RPSL license, we perform recruitment and manning
        with Indian seafarers for our managed vessels in full compliance with all
        regulations to ensure seafarer welfare. Our In-house recruitment ensures
        that we have experienced crew onboard on vessels who are trained as per
        vessel and industry requirements continually, which in turn promotes our
        seafarer’s professional growth.
        We are also engaged in complete Crewing Management and providing Indian
        seafarers to technical managers and vessel owners for a variety of ship
        types as per their commercial and operational requirements in compliance
        with ITF-NUSI/MUI CBA agreements.
      </p>
    ),
  },
];

const fadeInUp = {
  initial: { opacity: 0, y: 40 },
  animate: { opacity: 1, y: 0 },
};

const ServicesSection = () => {
  return (
    <section className="bg-gray-100 py-16">
      <div className="container mx-auto px-4">
        <div className="text-center mb-12">
          <h2 className="text-3xl font-bold mb-4 underline">Services</h2>
        </div>
        <div className="space-y-24">
          {services.map((service, idx) => (
            <motion.div
              key={idx}
              className={`flex flex-col-reverse md:flex-row ${
                idx % 2 !== 0 ? "md:flex-row-reverse" : ""
              } gap-10 items-center`}
              variants={fadeInUp}
              initial="initial"
              whileInView="animate"
              transition={{ duration: 0.6, delay: idx * 0.2 }}
              viewport={{ once: true }}
            >
              <div className="md:w-1/2 text-gray-700 space-y-4 leading-relaxed text-justify">
                <div className="relative w-fit">
                  <h3 className="text-2xl font-bold text-gray-800">
                    {service.title}
                  </h3>
                  <motion.span
                    className="absolute left-0 bottom-0 h-0.5 bg-blue-400 rounded"
                    initial={{ width: 0 }}
                    whileInView={{ width: "100%" }}
                    transition={{ duration: 1, ease: "easeInOut" }}
                    viewport={{ once: true }}
                  />
                </div>
                {service.content}
              </div>
              <div className="md:w-1/2 w-full">
                <motion.img
                  src={service.image}
                  alt={service.title}
                  className="rounded-xl shadow-lg w-full object-cover transition-transform duration-300 hover:scale-105"
                  whileHover={{ scale: 1.05 }}
                />
              </div>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default ServicesSection;
